import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './BotTyping.scss';
import { resetBotTyping } from 'shared/redux/actions';

/** Stateless Component: BotTyping - use to display when bot is typing messages */
// eslint-disable-next-line no-shadow
const BotTyping = ({ isTyping, resetBotTyping, alwaysShow }) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (isTyping) {
      setDisplay(isTyping);
      setTimeout(() => {
        setDisplay(0);
        resetBotTyping();
      }, isTyping);
    }
  }, [isTyping, resetBotTyping]);

  return (
    <div className={`typing-indicator ${(display || alwaysShow) && 'show'}`}>
      <span />
      <span />
      <span />
    </div>
  );
};

BotTyping.propTypes = {
  /** is bot typing */
  isTyping: PropTypes.number,
  resetBotTyping: PropTypes.func,
  alwaysShow: PropTypes.bool,
};

BotTyping.defaultProps = {
  isTyping: 0,
  resetBotTyping: () => {},
  alwaysShow: false,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  resetBotTyping: () => dispatch(resetBotTyping()),
});


export default connect(mapStateToProps,
  mapDispatchToProps)(BotTyping);
